module.exports = __webpack_public_path__ + "img/0-21.b8bb85ac.jpg";